import React, { useState } from "react";
import { Box, Button, Typography, Grid } from "@material-ui/core";

const CalculatorWidget = () => {
  const [display, setDisplay] = useState("0");
  const [equation, setEquation] = useState("");
  const [resetNext, setResetNext] = useState(false);

  const handleNum = (num) => {
    if (display === "0" || resetNext) {
      setDisplay(String(num));
      setResetNext(false);
    } else {
      if (display.length < 12) {
        setDisplay(display + num);
      }
    }
  };

  const handleOp = (op) => {
    setEquation(`${display} ${op} `);
    setResetNext(true);
  };

  const handleEqual = () => {
    if (!equation) return;
    try {
      const fullExpression = equation + display;
      // Sanitize expression to only contain valid numbers and operators
      const sanitized = fullExpression.replace(/×/g, "*").replace(/÷/g, "/");
      // Safe evaluation for basic math
      // eslint-disable-next-line no-eval
      const result = eval(sanitized);
      setDisplay(String(Number(result.toFixed(8))));
      setEquation("");
      setResetNext(true);
    } catch (e) {
      setDisplay("Erro");
      setResetNext(true);
    }
  };

  const handleClear = () => {
    setDisplay("0");
    setEquation("");
    setResetNext(false);
  };

  const handleBackspace = () => {
    if (display.length > 1 && !resetNext) {
      setDisplay(display.slice(0, -1));
    } else {
      setDisplay("0");
    }
  };

  const buttons = [
    { label: "C", action: handleClear, color: "#d32f2f" },
    { label: "⌫", action: handleBackspace, color: "#ed6c02" },
    { label: "÷", action: () => handleOp("÷"), color: "#1976d2" },
    { label: "×", action: () => handleOp("×"), color: "#1976d2" },

    { label: "7", action: () => handleNum(7) },
    { label: "8", action: () => handleNum(8) },
    { label: "9", action: () => handleNum(9) },
    { label: "-", action: () => handleOp("-"), color: "#1976d2" },

    { label: "4", action: () => handleNum(4) },
    { label: "5", action: () => handleNum(5) },
    { label: "6", action: () => handleNum(6) },
    { label: "+", action: () => handleOp("+"), color: "#1976d2" },

    { label: "1", action: () => handleNum(1) },
    { label: "2", action: () => handleNum(2) },
    { label: "3", action: () => handleNum(3) },
    { label: "=", action: handleEqual, color: "#2e7d32", span: 2 },

    { label: "0", action: () => handleNum(0), span: 2 },
    { label: ".", action: () => handleNum(".") },
  ];

  return (
    <Box style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      {/* Display area */}
      <Box
        style={{
          backgroundColor: "#1e1e1e",
          color: "#ffffff",
          padding: "10px 14px",
          borderRadius: 8,
          marginBottom: 10,
          textAlign: "right",
          userSelect: "none",
        }}
      >
        <Typography variant="caption" style={{ color: "#aaa", minHeight: 16, display: "block" }}>
          {equation}
        </Typography>
        <Typography
          variant="h5"
          style={{ fontWeight: "bold", fontFamily: "monospace", overflow: "hidden" }}
        >
          {display}
        </Typography>
      </Box>

      {/* Keyboard Grid */}
      <Grid container spacing={1} style={{ flexGrow: 1 }}>
        {buttons.map((btn, index) => (
          <Grid item xs={btn.span ? btn.span * 3 : 3} key={index}>
            <Button
              variant="contained"
              fullWidth
              onClick={btn.action}
              style={{
                backgroundColor: btn.color || "#ffffff",
                color: btn.color ? "#ffffff" : "#333333",
                fontWeight: "bold",
                fontSize: "1.1rem",
                minHeight: 40,
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                textTransform: "none",
              }}
            >
              {btn.label}
            </Button>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CalculatorWidget;
